import api from 'core/utils/api';

const validateOpts = ({ path }) => {
  if (!path) { new Error(`new Mapper: opts.path - expected: string, received: ${typeof path}`); }
};

class BaseMapper {
  constructor(opts = {}) {
    validateOpts(opts);
    Object.assign(this, opts);

    this.fetchAll = this.fetchAll.bind(this);
    this.fetchOne = this.fetchOne.bind(this);
    this.create = this.create.bind(this);
    this.patch = this.patch.bind(this);
    this.delete = this.delete.bind(this);
  }

  fetchAll(params) {
    return api.get(this.path, { params });
  }

  fetchOne(id, params = {}) {
    return api.get(`${this.path}/${id}`, { params });
  }

  create(payload) {
    return api.post(this.path, payload);
  }

  patch(id, payload) {
    return api.patch(`${this.path}/${id}`, payload);
  }

  delete(id) {
    return api.delete(`${this.path}/${id}`);
  }
}

export default BaseMapper;



// WEBPACK FOOTER //
// ./src/mappers/base-mapper.js